// extracted by mini-css-extract-plugin
export default {"showLessText":"TextMoreLess__showLessText___KrMmf","showMoreText":"TextMoreLess__showMoreText___LCVc9"};